<script>
import { mapGetters, mapActions } from 'vuex';
import { Field, Form } from 'vee-validate';
import * as Yup from 'yup';
import VInput from '@/components/Common/VInput';
import VSelect from '@/components/Common/VSelect';
import { loadBrands, loadModelsByBrandId } from './actions/GarantyForm';

const initFormData = () => ({
  brand: null,
  model: null,
  gosNumber: null,
  name: null,
  phone: null,
});

const STEPS = [
  ['brand', 'model', 'gosNumber'],
  ['name', 'phone']
];

export default {
  props: {
    dealers: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    VInput,
    VSelect,
    VeeForm: Form,
    VeeField: Field,
  },
  initFormData,
  STEPS,
  data() {
    return {
      form: this.$options.initFormData(),
      brands: [],
      models: [],
      currentStep: 0,
      errorMessage: null,
      loading: {
        brands: false,
        models: false
      }
    };
  },
  setup() {
    const schemaFirstStep = Yup.object().shape({
      brand: Yup.mixed().nullable(false).required(),
      model: Yup.mixed().nullable(false).required(),
      gosNumber: Yup.string().required(),
    });

    const schemaSecondStep = Yup.object().shape({
      name: Yup.string().required(),
      phone: Yup.string().required(),
    });

    return {
      schemaFirstStep,
      schemaSecondStep,
    };
  },
  watch: {
    model() {
      this.form.model = this.model;
    },
    'form.brand'() {
      this.loadModels();
    }
  },
  created() {
    this.loadBrands();
  },
  computed: {
    ...mapGetters({
      model: 'Service/model',
    }),
    continueButtonTitle() {
      if (this.currentStep) {
        return 'Записаться';
      }

      return 'Продолжить';
    }
  },
  methods: {
    ...mapActions({
      sendForm: 'Service/sendForm',
      setModels: 'Service/setModels',
    }),

    showError(message) {
      this.errorMessage = message;
    },
    onSubmit() {
      if (this.currentStep === 1) {
        const formData = {
          brand: Number(this.form.brand.id),
          model: Number(this.form.model.id),
          gosNumber: this.form.gosNumber,
          name: this.form.name,
          phone: this.form.phone,
        };
        this.sendForm(formData);
        this.reset();

        this.currentStep = 0;
      } else {
        this.currentStep++;
      }
    },
    comeBack() {
      this.currentStep--;
    },
    updateForm(form) {
      this.form = Object.assign(this.form, form);
    },
    totalText(item) {
      return item.name || String(item).replace('_', '');
    },
    resetFields() {
      this.form.model = null;
    },
    reset() {
      this.form = this.$options.initFormData();
    },
    async loadBrands() {
      this.loading.brands = true;
      this.brands = await loadBrands();
      this.loading.brands = false;
    },
    async loadModels() {
      if (this.form.brand) {
        this.loading.models = true;
        this.models = await loadModelsByBrandId(this.form.brand.id);
        this.loading.models = false;
      }
    },
  }, 
};
</script>

<template>
  <div>
    <vee-form
      :validation-schema="currentStep === 0 ? schemaFirstStep : schemaSecondStep"
      novalidate
      class="grid grid-cols-1 md:grid-cols-4 grid-rows-4 md:grid-rows-1 gap-[20px] mt-[40px]"
      @submit="onSubmit"
    >
      <template v-if="currentStep === 0">
        <vee-field
          v-slot="{ handleChange, errorMessage }"
          name="brand"
        >
          <v-select
            v-model="form.brand"
            :options="brands"
            :loading="loading.brands"
            placeholder="Выберите марку"
            theme="white"
            label="text"
            :error="errorMessage"
            @update:modelValue="handleChange"
          />
        </vee-field>

        <vee-field
          v-slot="{ handleChange, errorMessage }"
          name="model"
        >
          <v-select
            v-model="form.model"
            :options="models"
            :loading="loading.models"
            placeholder="Выберите модель"
            theme="white"
            label="text"
            :disabled="form.brand === null || form.brand.exception"
            :error="errorMessage"
            @update:modelValue="handleChange"
          />
        </vee-field>

        <vee-field
          v-slot="{ handleChange, errorMessage }"
          name="gosNumber"
        >
          <v-input
            key="gosNumber"
            v-model="form.gosNumber"
            placeholder="Госномер автомобиля"
            theme="white"
            format="gosNumber"
            :error="errorMessage"
            @update:modelValue="handleChange"
          />
        </vee-field>
      </template>
      <template v-else>
        <vee-field
          v-slot="{ handleChange, errorMessage }"
          name="name"
        >
          <v-input
            key="name"
            v-model="form.name"
            placeholder="Имя"
            theme="white"
            :error="errorMessage"
            @update:modelValue="handleChange"
          />
        </vee-field>
        <vee-field
          v-slot="{ handleChange, errorMessage }"
          name="phone"
        >
          <v-input
            key="phone"
            v-model="form.phone"
            theme="white"
            placeholder="+7 (___) ___-__-__"
            format="phone"
            :error="errorMessage"
            @update:modelValue="handleChange"
          />
        </vee-field>
      </template>
      <button
        type="submit"
        class="button button_green button_big w-full"
      >{{continueButtonTitle}}</button>
    </vee-form>
  </div>
</template>

